import { getSettingsOptions } from './getSettingsOptions.js';
import { getStylesOptions } from './getStylesOptions.js';
/**
 * Parses the passed theme.json object and returns a valid Block Theme schema.
 * @param theme The theme.json object
 */
export function fromThemeJson(theme) {
    const result = Object.entries(theme).reduce((acc, [key, value]) => {
        if (key === 'settings') {
            const fromSettings = getSettingsOptions(value);
            return Object.assign(Object.assign({}, acc), fromSettings);
        }
        if (key === 'styles') {
            const fromStyles = getStylesOptions(value);
            return Object.assign(Object.assign({}, acc), { styles: fromStyles });
        }
        return acc;
    }, {});
    return result;
}
